import { createContext, useContext, useMemo } from 'react';

export const defaultValue = {
  networkLoginUrl: null,
  networkRootUrl: null,
  topicId: window.Hivebrite?.topic?.id, // global variable set here app/views/layouts/_javascripts.html.haml,
  whitelabelURL: window.Hivebrite?.topic?.whitelabelURL, // global variable set here app/views/layouts/_javascripts.html.haml,
  whitelabelName: window.Hivebrite?.topic?.whitelabelName, // global variable set here app/views/layouts/_javascripts.html.haml,
  topicMenuRef: null,
  topic: null,
};

const TopicContext = createContext(defaultValue);

export const useTopicContext = () => useContext(TopicContext);

export const TopicProvider = ({ children, topic }) => {
  const contextValues = useTopicContext();
  const providerState = useMemo(
    () => ({ ...contextValues, topic }),
    [topic, contextValues],
  );

  return (
    <TopicContext.Provider value={providerState}>
      {children}
    </TopicContext.Provider>
  );
};

export const withTopicContext = (Component) => (props) => {
  const contextValue = useTopicContext();

  return <Component {...props} {...contextValue} />;
};

export default TopicContext;
